module.exports = {"371329001":"临沭街道","371329002":"郑山街道","371329101":"蛟龙镇","371329102":"大兴镇","371329103":"石门镇","371329104":"曹庄镇","371329108":"青云镇","371329109":"玉山镇","371329110":"店头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371329.json
// module id = 1352
// module chunks = 0